'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = exports.styleSheet = exports.DISPLAY_NAME = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _PropTypes = require('../utils/PropTypes');

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _jssThemeReactor = require('jss-theme-reactor');

var _Modal = require('../internal/Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _Fade = require('../transitions/Fade');

var _Fade2 = _interopRequireDefault(_Fade);

var _transitions = require('../styles/transitions');

var _Paper = require('../Paper');

var _Paper2 = _interopRequireDefault(_Paper);

var _Form = require('../Form');

var _Form2 = _interopRequireDefault(_Form);

var _Button = require('../Button');

var _Button2 = _interopRequireDefault(_Button);

var _DialogActions = require('./DialogActions');

var _DialogActions2 = _interopRequireDefault(_DialogActions);

var _DialogTitle = require('./DialogTitle');

var _DialogTitle2 = _interopRequireDefault(_DialogTitle);

var _Text = require('../Text');

var _Progress = require('../Progress');

var _Progress2 = _interopRequireDefault(_Progress);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DISPLAY_NAME = exports.DISPLAY_NAME = 'Dialog';

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)(DISPLAY_NAME, function (theme) {
  var _ref;

  return _ref = {
    modal: {
      justifyContent: 'center',
      alignItems: 'center'
    },
    dialog: {
      display: 'flex',
      position: 'relative',
      width: '75%',
      maxHeight: parseInt(theme.typography.rhythmByUnit(11)) + 'vh',
      '&:focus': {
        outline: 'none'
      }
    },
    dialogContent: {
      flex: '1 1 auto',
      overflow: 'auto'
    },
    dialogTitle: {
      flex: '0 0 auto'
    },
    overflow: {
      overflow: 'auto'
    },
    form: {
      display: 'flex',
      flexDirection: 'column',
      flex: 'auto',
      maxHeight: parseInt(theme.typography.rhythmByUnit(11)) + 'vh',
      width: '100%'
    },
    progress: {
      zIndex: theme.zIndex.dialog
    },
    title: theme.mixins.truncate({
      flex: '1'
    }),
    titleCaption: {
      whiteSpace: 'pre-line'
    },
    actionTitle: {
      display: 'none'
    },
    close: {
      margin: '0 ' + theme.typography.rhythmByUnit(0.5)
    },
    'dialogWidth-xs': {
      maxWidth: theme.breakpoints.getWidth('xs')
    },
    'dialogWidth-sm': {
      maxWidth: theme.breakpoints.getWidth('sm')
    },
    'dialogWidth-md': {
      maxWidth: theme.breakpoints.getWidth('md')
    },
    embeddedModal: {
      justifyContent: 'flex-start',
      alignItems: 'stretch',
      top: theme.variables.modalSheetHeaderHeight,
      height: 'calc(100% - ' + theme.variables.modalSheetHeaderHeight + ')',
      backgroundColor: theme.palette.background.paper
    },
    embeddedDialog: {
      width: '100%',
      maxWidth: 'none',
      maxHeight: 'none'
    },
    embeddedForm: {
      margin: '0 auto',
      maxHeight: 'none',
      maxWidth: theme.breakpoints.getWidth('sm')
    },
    embeddedProgress: {
      position: 'fixed',
      top: 0,
      width: '100%'
    }
  }, _defineProperty(_ref, theme.breakpoints.down('sm'), {
    fullScreenActionFooter: {
      display: 'none'
    },
    fullScreen: {
      width: '100%',
      height: '100%',
      minHeight: '100%',
      borderRadius: 0,
      overflowY: 'auto'
    },
    fullScreenDialogTitle: {
      paddingRight: 0
    },
    fullScreenForm: {
      marginTop: theme.typography.rhythmByUnit(10)
    },
    titleCaption: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    }
  }), _defineProperty(_ref, theme.breakpoints.up('sm'), {
    fullScreenActionTitle: {
      display: 'none'
    }
  }), _ref;
});

/**
 * Dialogs are overlayed modal paper based components with a backdrop.
 *
 * ```jsx
 * <Dialog>
 *   <DialogContent>...</DialogContent>
 *   <DialogActions>...</DialogActions>
 * </Dialog>
 * ```
 */
var Dialog = (_temp2 = _class = function (_Component) {
  _inherits(Dialog, _Component);

  function Dialog() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, Dialog);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Dialog.__proto__ || Object.getPrototypeOf(Dialog)).call.apply(_ref2, [this].concat(args))), _this), _this.handleOnCloseClick = function (event) {
      var _this$props = _this.props,
          onCloseClick = _this$props.onCloseClick,
          onRequestClose = _this$props.onRequestClose,
          hideOnCloseClick = _this$props.hideOnCloseClick;


      if (onCloseClick) {
        onCloseClick(event);
      }

      if (onRequestClose && hideOnCloseClick) {
        onRequestClose(event);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Dialog, [{
    key: 'render',
    value: function () {
      function render() {
        var _classNames, _classNames3, _classNames5;

        var _props = this.props,
            accent = _props.accent,
            children = _props.children,
            bodyClassName = _props.bodyClassName,
            className = _props.className,
            closeClassName = _props.closeClassName,
            closeComponent = _props.closeComponent,
            closeIconComponent = _props.closeIconComponent,
            actions = _props.confirmationActions,
            ConfirmationActions = _props.confirmationActionsComponent,
            confirmationActionsClassName = _props.confirmationActionsClassName,
            contentClassName = _props.contentClassName,
            disableOverflow = _props.disableOverflow,
            embeddedMode = _props.embeddedMode,
            error = _props.error,
            Form = _props.formComponent,
            fullScreenProp = _props.fullScreen,
            hideOnBackdropClick = _props.hideOnBackdropClick,
            hideOnCloseClick = _props.hideOnCloseClick,
            hideOnEscapeKeyUp = _props.hideOnEscapeKeyUp,
            enterTransitionDuration = _props.enterTransitionDuration,
            leaveTransitionDuration = _props.leaveTransitionDuration,
            maxWidth = _props.maxWidth,
            open = _props.open,
            onBackdropClick = _props.onBackdropClick,
            onCloseClick = _props.onCloseClick,
            onEscapeKeyUp = _props.onEscapeKeyUp,
            onEnter = _props.onEnter,
            onEntering = _props.onEntering,
            onEntered = _props.onEntered,
            onExit = _props.onExit,
            onExiting = _props.onExiting,
            onExited = _props.onExited,
            onRequestClose = _props.onRequestClose,
            onSubmit = _props.onSubmit,
            onValidate = _props.onValidate,
            paperClassNameProp = _props.paperClassName,
            progress = _props.progress,
            primary = _props.primary,
            secondary = _props.secondary,
            title = _props.title,
            titleCaption = _props.titleCaption,
            DialogTitle = _props.titleComponent,
            titleClassName = _props.titleClassName,
            transition = _props.transition,
            other = _objectWithoutProperties(_props, ['accent', 'children', 'bodyClassName', 'className', 'closeClassName', 'closeComponent', 'closeIconComponent', 'confirmationActions', 'confirmationActionsComponent', 'confirmationActionsClassName', 'contentClassName', 'disableOverflow', 'embeddedMode', 'error', 'formComponent', 'fullScreen', 'hideOnBackdropClick', 'hideOnCloseClick', 'hideOnEscapeKeyUp', 'enterTransitionDuration', 'leaveTransitionDuration', 'maxWidth', 'open', 'onBackdropClick', 'onCloseClick', 'onEscapeKeyUp', 'onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited', 'onRequestClose', 'onSubmit', 'onValidate', 'paperClassName', 'progress', 'primary', 'secondary', 'title', 'titleCaption', 'titleComponent', 'titleClassName', 'transition']);

        var fullScreen = fullScreenProp && !embeddedMode;

        var confirmationActions = actions;
        var closeConfirmationActions = void 0;

        var classes = this.context.styleManager.render(styleSheet);

        if (!embeddedMode) {
          if (fullScreen && !confirmationActions) {
            closeConfirmationActions = _react2['default'].createElement(
              _Button2['default'],
              {
                accent: true,
                className: classes.close,
                colorInherit: true,
                key: 'close',
                onClick: onRequestClose,
                raised: true,
                type: 'button'
              },
              'Close'
            );
          }

          if (fullScreen && confirmationActions) {
            closeConfirmationActions = _react2['default'].createElement(
              _Button2['default'],
              {
                className: classes.close,
                colorInherit: true,
                key: 'close',
                onClick: onRequestClose,
                raised: true,
                type: 'button'
              },
              'Cancel'
            );
          }
        }

        var formProps = {
          confirmationActionsComponent: ConfirmationActions,
          confirmationActionsClassName: confirmationActionsClassName,
          className: (0, _classnames2['default'])(classes.form, (_classNames = {}, _defineProperty(_classNames, classes.fullScreenForm, fullScreen), _defineProperty(_classNames, classes.embeddedForm, embeddedMode), _classNames), bodyClassName),
          onSubmit: onSubmit,
          onValidate: onValidate
        };

        var modalClassName = (0, _classnames2['default'])(classes.modal, _defineProperty({}, classes.embeddedModal, embeddedMode), className);

        var paperClassName = (0, _classnames2['default'])(classes.dialog, classes['dialogWidth-' + maxWidth], paperClassNameProp, (_classNames3 = {}, _defineProperty(_classNames3, classes.fullScreen, fullScreen), _defineProperty(_classNames3, classes.overflow, !disableOverflow), _defineProperty(_classNames3, classes.embeddedDialog, embeddedMode), _classNames3));

        var progressClassName = (0, _classnames2['default'])(classes.progress, _defineProperty({}, classes.embeddedProgress, embeddedMode));

        var confirmationActionsTitleClassName = (0, _classnames2['default'])((_classNames5 = {}, _defineProperty(_classNames5, classes.actionTitle, !fullScreen), _defineProperty(_classNames5, classes.fullScreenActionTitle, fullScreen), _classNames5), confirmationActionsClassName);

        var confirmationActionsFooterClassName = (0, _classnames2['default'])(_defineProperty({}, classes.fullScreenActionFooter, fullScreen), confirmationActionsClassName);

        var titleProps = {
          accent: accent,
          closeClassName: closeClassName,
          closeComponent: closeComponent,
          closeIconComponent: closeIconComponent,
          error: error,
          onCloseClick: this.handleOnCloseClick,
          primary: primary,
          secondary: secondary,
          paperClassName: classes.dialogTitle,
          className: (0, _classnames2['default'])(_defineProperty({}, classes.fullScreenDialogTitle, confirmationActions && fullScreen), titleClassName),
          fullScreen: fullScreen
        };

        var dialogContent = _react2['default'].createElement(
          _Paper2['default'],
          {
            rounded: false,
            'data-mui-test': DISPLAY_NAME,
            elevation: embeddedMode ? 0 : 24,
            className: paperClassName
          },
          _react2['default'].createElement(
            Form,
            formProps,
            progress && _react2['default'].createElement(_Progress2['default'], { className: progressClassName }),
            (title || fullScreen) && _react2['default'].createElement(
              DialogTitle,
              titleProps,
              _react2['default'].createElement(
                'div',
                { className: classes.title },
                _react2['default'].createElement(
                  _Text.Title,
                  { colorInherit: true },
                  title
                ),
                _react2['default'].createElement(
                  _Text.Caption,
                  {
                    noWrap: false,
                    colorInherit: true,
                    className: classes.titleCaption
                  },
                  titleCaption
                )
              ),
              confirmationActions && fullScreen && _react2['default'].createElement(
                ConfirmationActions,
                {
                  id: 'dialog-title-actions',
                  className: confirmationActionsTitleClassName
                },
                confirmationActions
              )
            ),
            _react2['default'].createElement(
              'div',
              { className: classes.dialogContent },
              children
            ),
            confirmationActions && _react2['default'].createElement(
              ConfirmationActions,
              {
                id: 'dialog-footer-actions',
                className: confirmationActionsFooterClassName,
                closeConfirmation: closeConfirmationActions
              },
              confirmationActions
            )
          )
        );

        var content = void 0;

        if (embeddedMode) {
          content = dialogContent;
        } else {
          var transitionProps = {
            'in': open,
            transitionAppear: true,
            className: contentClassName,
            enterTransitionDuration: enterTransitionDuration,
            leaveTransitionDuration: leaveTransitionDuration,
            onEnter: onEnter,
            onEntering: onEntering,
            onEntered: onEntered,
            onExit: onExit,
            onExiting: onExiting,
            onExited: onExited
          };
          var createTransitionFn = typeof transition === 'function' ? _react2['default'].createElement : _react2['default'].cloneElement;

          content = createTransitionFn(transition, transitionProps, dialogContent);
        }

        return _react2['default'].createElement(
          _Modal2['default'],
          _extends({
            className: modalClassName,
            backdrop: !embeddedMode,
            backdropTransitionDuration: open ? enterTransitionDuration : leaveTransitionDuration,
            hideOnBackdropClick: hideOnBackdropClick,
            hideOnEscapeKeyUp: hideOnEscapeKeyUp,
            onBackdropClick: onBackdropClick,
            onEscapeKeyUp: onEscapeKeyUp,
            onRequestClose: onRequestClose,
            show: open
          }, other),
          content
        );
      }

      return render;
    }()
  }]);

  return Dialog;
}(_react.Component), _class.propTypes = {
  /**
   * If `true`, the text will use the theme's accent color.
   */
  accent: _PropTypes2['default'].bool,
  /**
   * The CSS class name of the body element.
   */
  bodyClassName: _PropTypes2['default'].string,
  /**
   * Dialog children, usually the included sub-components.
   */
  children: _PropTypes2['default'].node,
  /**
   * The CSS class name of the root element.
   */
  className: _PropTypes2['default'].string,
  /**
   * The CSS class name of the close element.
   */
  closeClassName: _PropTypes2['default'].string,
  /**
   * Component to be used as the close element
   */
  closeComponent: _PropTypes2['default'].oneOfType([_PropTypes2['default'].string, _PropTypes2['default'].func]),
  /**
   * Component to be used as the close element
   */
  closeIconComponent: _PropTypes2['default'].oneOfType([_PropTypes2['default'].string, _PropTypes2['default'].func]),
  /**
   * Nodes to be placed in the confirmation action container.
   */
  confirmationActions: _Form2['default'].propTypes.confirmationActions,
  /**
   * Component to be used as the confirmation action node
   */
  confirmationActionsComponent: _Form2['default'].propTypes.confirmationActionsComponent,
  /**
   * The CSS class name of the confirmation action element.
   */
  confirmationActionsClassName: _PropTypes2['default'].string,
  /**
   * The CSS class name of the content element.
   */
  contentClassName: _PropTypes2['default'].string,
  /**
   * If `true`, removes overflow styling on `Paper` component
   */
  disableOverflow: _PropTypes2['default'].bool,
  /**
   * If `true`, the dialog will have embedded mode styles
   */
  embeddedMode: _PropTypes2['default'].bool,
  /**
   * If `true`, the text will use the theme's error color.
   */
  error: _PropTypes2['default'].bool,
  /**
   * Component to be used as the form
   */
  formComponent: _Form2['default'].propTypes.formComponent,
  /**
   * If `true`, The dialog will be full-screen.
   */
  fullScreen: _PropTypes2['default'].bool,
  /**
   * If `true`, clicking the backdrop will fire the `onRequestClose` callback.
   */
  hideOnBackdropClick: _PropTypes2['default'].bool,
  /**
   * If `true`, hitting escape will fire the `onRequestClose` callback.
   */
  hideOnEscapeKeyUp: _PropTypes2['default'].bool,
  /**
   * If `true`, clicking the close will fire the `onRequestClose` callback.
   */
  hideOnCloseClick: _PropTypes2['default'].bool,
  /**
   * Duration of the animation when the element is entering the screen.
   */
  enterTransitionDuration: _PropTypes2['default'].number, // int-disable-line react/sort-prop-types
  /**
   * Duration of the animation when the element is leaving the screen.
   */
  leaveTransitionDuration: _PropTypes2['default'].number,
  /**
   * Determine the max width of the dialog.
   * The dialog width grows with the size of the screen, this property is useful
   * on the desktop where you might need some coherent different width size across your
   * application.
   */
  maxWidth: _PropTypes2['default'].oneOf(['xs', 'sm', 'md']),
  /**
   * Callback fires when the backdrop is clicked on.
   */
  onBackdropClick: _PropTypes2['default'].func,
  /**
   * Callback fires when the close icon is clicked on.
   */
  onCloseClick: _PropTypes2['default'].func,
  /**
   * Callback fired before the dialog is entering.
   */
  onEnter: _PropTypes2['default'].func,
  /**
   * Callback fired when the dialog is entering.
   */
  onEntering: _PropTypes2['default'].func,
  /**
   * Callback fired when the dialog has entered.
   */
  onEntered: _PropTypes2['default'].func, // eslint-disable-line react/sort-prop-types
  /**
   * Callback fires when the escape key is pressed and the modal is in focus.
   */
  onEscapeKeyUp: _PropTypes2['default'].func, // eslint-disable-line react/sort-prop-types
  /**
   * Callback fired before the dialog is exiting.
   */
  onExit: _PropTypes2['default'].func,
  /**
   * Callback fired when the dialog is exiting.
   */
  onExiting: _PropTypes2['default'].func,
  /**
   * Callback fired when the dialog has exited.
   */
  onExited: _PropTypes2['default'].func, // eslint-disable-line react/sort-prop-types
  /**
   * Callback fired when the dialog requests to be closed.
   */
  onRequestClose: _PropTypes2['default'].func,
  /**
   * Callback fired when form is submitted
   */
  onSubmit: _PropTypes2['default'].func,
  /**
   * Callback fired when form is validated
   */
  onValidate: _PropTypes2['default'].func,
  /**
   * Set to true to open the Dialog.
   */
  open: _PropTypes2['default'].bool,
  /**
   * If `true`, Progress will appear in DialogTitle.
   */
  progress: _PropTypes2['default'].bool,
  /**
   * The CSS class name of the paper inner element.
   */
  paperClassName: _PropTypes2['default'].string,
  /**
   * If `true`, the text will use the theme's primary color.
   */
  primary: _PropTypes2['default'].bool,
  /**
   * If `true`, the text will use the theme's secondary color.
   */
  secondary: _PropTypes2['default'].bool,
  /**
   * Node to be placed in the title container.
   */
  title: _PropTypes2['default'].node,
  /**
   * Node to be placed in the title caption container.
   */
  titleCaption: _PropTypes2['default'].node,
  /**
   * Component to be used as the title node
   */
  titleComponent: _PropTypes2['default'].oneOfType([_PropTypes2['default'].string, _PropTypes2['default'].func]),
  /**
   * The CSS class name of the title element.
   */
  titleClassName: _PropTypes2['default'].string,
  /**
   * Transition component.
   */
  transition: _PropTypes2['default'].oneOfType([_PropTypes2['default'].func, _PropTypes2['default'].element])
}, _class.defaultProps = {
  confirmationActionsComponent: _DialogActions2['default'],
  disableOverflow: false,
  embeddedMode: false,
  formComponent: _Form2['default'],
  fullScreen: false,
  hideOnBackdropClick: true,
  hideOnCloseClick: true,
  hideOnEscapeKeyUp: true,
  enterTransitionDuration: _transitions.duration.enteringScreen,
  leaveTransitionDuration: _transitions.duration.leavingScreen,
  maxWidth: 'sm',
  open: false,
  progress: false,
  transition: _Fade2['default'],
  titleComponent: _DialogTitle2['default']
}, _class.contextTypes = {
  styleManager: _PropTypes2['default'].styleManager.isRequired
}, _temp2);
exports['default'] = Dialog;


Dialog.displayName = DISPLAY_NAME;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/Dialog/Dialog.js
// module id = 773
// module chunks = 32